import React from "react";
import PropTypes from "prop-types"; 
import moment from "moment";

const AuctionStatus = ({ aucSD, aucED }) => {
    console.log("aucSD",aucSD);
  const currentTime = Date.now();

  if (aucED <= currentTime) {
    // Auction has ended
    return (
      <span>
        Ended at {moment(aucED).format("ddd, Do MMM YYYY")}
      </span>
    );
  } else {
    // Auction is ongoing, calculate the remaining time
    const duration = moment.duration(aucED - currentTime);

    const days = Math.floor(duration.asDays());
    const hours = duration.hours();
    const minutes = duration.minutes();

    return (
      <span>
        {days > 0 && `${days} days `}
        {hours > 0 && `${hours} hours `}
        {minutes > 0 && `${minutes} minutes `}
        left
      </span>
    );
  }
};

// PropTypes validation
AuctionStatus.propTypes = {
    aucSD: PropTypes.number.isRequired, // Validate aucSD as a required number
    aucED: PropTypes.number.isRequired, // Validate aucED as a required number
  };
export default AuctionStatus;
